<template>
	<div
		class="courseVideo"
		:style="{
			marginTop: data.marginTop + 'px',
			paddingTop: data.paddingTop + 'px',
			paddingLeft: data.paddingLeft + '%',
			paddingRight: data.paddingRight + '%',
		}"
	>
		<div class="courseCatalogue" v-if="data.catalogTitle || data.data.length > 0">
			<div class="video" ref="videocomp">
				<video ref="videoPlayer" class="video-js vjs-default-skin vjs-big-play-centered vjs-16-9" style="width: 100%" poster="../../assets/images/video_poster.png"></video>
				<div class="container paddingSize">
					<div class="title">{{ data.catalogTitle }}</div>
					<div class="catalog">
						<div class="catalog-title">课程目录</div>
					</div>
					<div class="list" ref="box">
						<div class="item" :class="{ 'item-active': index + 1 == type }" v-for="(item, index) in data.data" :key="index" @click="playVideo(index, item.videoUrl)">
							<div class="item-num">{{ item.title }}</div>
							<div class="item-title">{{ item.subTitle }}</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="courseCatalogue" v-else>
			<div class="video" ref="videocomp">
				<video ref="videoPlayer" class="video-js vjs-default-skin vjs-big-play-centered vjs-16-9" style="width: 100%" poster="../../assets/images/video_poster.png"></video>
				<div class="container paddingSize">
					<div class="title">灵源万应助名医系列课程</div>
					<div class="catalog">
						<div class="catalog-title">课程目录</div>
					</div>
					<div class="list" ref="box">
						<div class="item">
							<div class="item-num">01</div>
							<div class="item-title">普通感冒</div>
						</div>
						<div class="item">
							<div class="item-num">02</div>
							<div class="item-title">流行性感冒与风温、暑温</div>
						</div>
						<div class="item">
							<div class="item-num">03</div>
							<div class="item-title">痊夏、秋燥、痢疾</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Video from 'video.js';
import 'video.js/dist/video-js.css';
export default {
	name: 'courseCatalogue',
	props: ['data'],
	data() {
		return {
			type: 1,
			options: {
				playbackRates: [0.5, 1, 1.5, 2],
				autoplay: true,
				controls: true,
				playsinline: true,
				poster: '',
				sources: [
					{
						src: '',
						type: 'video/mp4',
					},
				],
				controlBar: {
					pictureInPictureToggle: false,
				},
			},
		};
	},
	mounted() {
		if (this.data.data.length > 0) {
			var pageNum = Number(this.$route.query.pageNum);
			if (pageNum != undefined && pageNum != NaN && pageNum >= 0) {
				if (pageNum > this.data.data.length - 1) {
					var videoUrl = this.data.data[this.data.data.length - 1].videoUrl;
					this.type = this.data.data.length;
				} else {
					var videoUrl = this.data.data[pageNum].videoUrl;
					this.type = pageNum + 1;
				}
			} else {
				var videoUrl = this.data.data[0].videoUrl;
			}

			this.options.sources = [
				{
					src: videoUrl,
					type: 'video/mp4',
				},
			];
		}
		this.player = Video(this.$refs.videoPlayer, this.options, function onPlayerReady() {
			// console.log('onPlayerReady', this);
		});
		this.$nextTick(function () {
			this.$refs.videocomp.scrollTo(0, 0);
			this.$refs.box.scrollTo(160 * pageNum, 0);
		});
	},

	methods: {
		playVideo(index, videoUrl) {
			if (this.type == index + 1) return false;
			this.type = index + 1;
			this.player.src([
				{
					src: videoUrl,
					type: 'video/mp4',
				},
			]);
		},
	},
};
</script>

<style lang="scss" scoped>
@import '../../assets/css/curriculum.scss';
// ::-webkit-scrollbar {
// 	height: 3px;
// }

// ::-webkit-scrollbar-thumb {
// 	background-color: #cfcfcf;
// }
.courseCatalogue {
	background-color: #fff;
}
.title {
	padding: 20px 0;
	font-size: 18px;
	font-weight: bold;
	color: #141419;
}
.catalog {
	display: flex;
	justify-content: space-between;
	padding-bottom: 12px;
}
.catalog-title {
	font-size: 15px;
	font-weight: bold;
	color: #141419;
}
.list {
	padding-bottom: 10px;
	white-space: nowrap;
	overflow-y: auto;
}
.item {
	display: inline-block;
	position: relative;
	width: 160px;
	height: 65px;
	padding: 15px;
	background: url('../../assets/img/ly/item-back-null.png') no-repeat;
	background-size: 100% 100%;
	box-sizing: border-box;
	overflow: hidden;
}
.item-active {
	background: url('../../assets/img/ly/item-back.png') no-repeat;
	background-size: 100% 100%;
}
.item-num {
	font-size: 13px;
	color: #7b7a7f;
}
.item-title {
	width: 100%;
	padding-top: 2px;
	font-size: 14px;
	font-weight: bold;
	color: #2e2e2e;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}
.item-active .item-num,
.item-active .item-title {
	color: #1fbb8a;
}
</style>